import React, { useEffect , useContext } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';
import {Context} from "../../../store/reducer";

/**
 * geojson用の汎用マーカー
 * 
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({feature, menu, option}) => {
  
  const { state } = useContext(Context);

  const icon = menu2icon[option.id] || menu2icon["default"]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const latitude = feature.geometry.coordinates[1]
  const longitude = feature.geometry.coordinates[0]

  // ポップアップの表示内容の加工
  const createPopupContent = (feature, option) => {

    let ret = []

    const managerCode = {
      "1":"国",
      "2":"都道府県",
      "3":"市区町村",
      "4":"民間",
      "9":"不明",
      "0":"その他",
    }

    // 学校データ
    if (option.fetchedServerKey === "XKT006") {

      let schoolManagementCode = feature.properties.P29_006.toString()

      ret.push(<dl className='dl-list is-modal-spot'><dt>学校分類コード</dt><dd>{option.label}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.properties.P29_004_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.P29_005_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>管理者コード</dt><dd>{managerCode[schoolManagementCode]}</dd></dl>)
    
    } else if (option.fetchedServerKey === "XKT007") {
    
      // デバッグ可能なようにいったん保持
      let administratorCode = feature.properties.administratorCode.toString()

      if (feature.properties["schoolClassCode"] != "") {

        // 幼稚園
        ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.properties.preSchoolName_ja}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>学校分類コード</dt><dd>{option.label}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.location_ja}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>管理者コード</dt><dd>{managerCode[administratorCode]}</dd></dl>)
      } else if (feature.properties["welfareFacilityMiddleClassCode"] != "") {

        // 保育園
        ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.properties.preSchoolName_ja}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>福祉施設中分類コード</dt><dd>{option.label}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.location_ja}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>管理者コード</dt><dd>{managerCode[administratorCode]}</dd></dl>)
      }
    } else if (option.fetchedServerKey === "XKT010") {

      const hospitalManagerCodeList = {
        "1":"国",
        "2":"公的医療機関",
        "3":"社会保険関係団体",
        "4":"医療法人",
        "5":"個人",
        "6":"その他",
        "9":"分類対象外",
      }

      const disasterHospitalCodeList = {
        "1":"基幹災害拠点病院",
        "2":"地域災害拠点病院",
        "9":"指定なし",
      }

      let hospitalManagerCode = feature.properties.P04_007.toString()
      let disasterHospitalCode = feature.properties.P04_010.toString()
      

      ret.push(<dl className='dl-list is-modal-spot'><dt>医療機関分類</dt><dd>{option.label}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>施設名称</dt><dd>{feature.properties.P04_002_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.P04_003_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>診療科目１</dt><dd>{feature.properties.P29_005_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>診療科目2</dt><dd>{feature.properties.P04_004}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>診療科目3</dt><dd>{feature.properties.P04_006}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>開設者分類</dt><dd>{hospitalManagerCodeList[hospitalManagerCode]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>病床数</dt><dd>{feature.properties.P04_008}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>災害拠点病院</dt><dd>{disasterHospitalCodeList[disasterHospitalCode]}</dd></dl>)
    
    }  else if (option.fetchedServerKey === "XKT011") {

      // 福祉施設中分類コード
      const welfareMiddleCategoryCodeList = {
        "0100":"－",
        "0101":"救護施設",
        "0102":"更生施設",
        "0103":"医療保護施設",
        "0104":"授産施設（保護）",
        "0105":"宿所提供施設",
        "0199":"その他",
        "0200":"－",
        "0201":"養護老人ホーム",
        "0202":"軽費老人ホーム",
        "0203":"老人福祉センター",
        "0204":"老人デイサービスセンター",
        "0205":"老人短期入所施設",
        "0206":"老人（在宅）介護支援センター",
        "0207":"高齢者生活福祉センター",
        "0299":"その他",
        "0300":"－",
        "0301":"障害者支援施設",
        "0302":"地域活動支援センター",
        "0303":"福祉ホーム",
        "0399":"その他",
        "0400":"－",
        "0401":"身体障害者福祉センター",
        "0402":"障害者更生センター",
        "0403":"補装具製作施設",
        "0404":"盲導犬訓練施設",
        "0405":"視聴覚障害者情報提供施設",
        "0499":"その他",
        "0500":"－",
        "0501":"助産施設",
        "0502":"乳児院",
        "0503":"母子生活支援施設",
        "0504":"保育所等",
        "0505":"地域型保育事業所",
        "0506":"認可外保育施設",
        "0507":"児童養護施設",
        "0508":"障害児入所施設",
        "0509":"児童発達支援センター",
        "0510":"児童心理治療施設",
        "0511":"児童自立支援施設",
        "0512":"児童家庭支援センター",
        "0513":"児童館",
        "0514":"児童遊園",
        "0599":"その他",
        "0600":"－",
        "0601":"母子・父子福祉センター",
        "0602":"母子・父子休養ホーム",
        "0699":"その他",
        "9901":"無料低額宿泊所（宿所提供施設）",
        "9902":"授産施設（その他）",
        "9903":"盲人ホーム",
        "9904":"無料低額診療施設",
        "9905":"隣保館",
        "9906":"へき地保健福祉館",
        "9907":"有料老人ホーム",
        "9908":"老人憩の家",
        "9909":"地域福祉センター",
        "9910":"介護保険等の施設",
        "9911":"障害者サービス施設",
        "9912":"児童福祉サービス施設",
        "9913":"相談所等の施設",
        "9999":"その他",
      }

      let welfareMiddleCategoryCode = feature.properties.P14_006.toString()
      let welfareManagerCode = feature.properties.P14_009.toString()

      ret.push(<dl className='dl-list is-modal-spot'><dt>市区町村名</dt><dd>{feature.properties.P14_002}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.P14_004_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>福祉施設大分類コード</dt><dd>{option.label}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>福祉施設中分類コード</dt><dd>{welfareMiddleCategoryCodeList[welfareMiddleCategoryCode]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.properties.P14_008_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>管理者コード</dt><dd>{managerCode[welfareManagerCode]}</dd></dl>)
    
    } else if (option.fetchedServerKey === "XKT017") {

      // 図書館
      ret.push(<dl className='dl-list is-modal-spot'><dt>文化施設分類</dt><dd>{option.label}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.properties.P27_005_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.P27_006_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>管理者コード</dt><dd>{managerCode[feature.properties.P27_007]}</dd></dl>)
    
    } else if (option.fetchedServerKey === "XKT018") {

      const officeTypeCodeList = {
        "1":"市役所・区役所・町役場",
        "2":"支所・出張所・連絡所",
        "3":"その他の行政サービス施設",
        "4":"公立公民館",
        "5":"その他の公的集会施設",
      }

      let officeTypeCode = feature.properties.P05_002.toString()

      // 役場・出張所
      ret.push(<dl className='dl-list is-modal-spot'><dt>施設分類コード</dt><dd>{officeTypeCodeList[officeTypeCode]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>名称</dt><dd>{feature.properties.P05_003_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>所在地</dt><dd>{feature.properties.P05_004_ja}</dd></dl>)

    } else if (option.fetchedServerKey === "XKT015") {

      const operatorTypeCodeList = {
        "1":"JR新幹線",
        "2":"JR在来線",
        "3":"公営鉄道",
        "4":"民営鉄道",
        "5":"第三セクター",
      }

      let operatorTypeCode = feature.properties.S12_005.toString()

      // 駅
      ret.push(<dl className='dl-list is-modal-spot'><dt>駅名</dt><dd>{feature.properties.S12_001_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>運営会社</dt><dd>{feature.properties.S12_002_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>路線名</dt><dd>{feature.properties.S12_003_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>事業者種別</dt><dd>{operatorTypeCodeList[operatorTypeCode]}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>乗降客数2016</dt><dd>{feature.properties.S12_029}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>乗降客数2017</dt><dd>{feature.properties.S12_033}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>乗降客数2018</dt><dd>{feature.properties.S12_037}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>乗降客数2019</dt><dd>{feature.properties.S12_041}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>乗降客数2020</dt><dd>{feature.properties.S12_045}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>乗降客数2021</dt><dd>{feature.properties.S12_049}</dd></dl>)

    } else if (option.fetchedServerKey === "XPT001") {

      // 不動産取引価格情報・成約価格情報
        
      ret.push(<dl className='dl-list is-modal-spot'><dt>価格情報区分</dt><dd>{feature.properties.price_information_cagegory_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>都道府県名</dt><dd>{feature.properties.prefecture_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>市区町村名</dt><dd>{feature.properties.city_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>地区名</dt><dd>{feature.properties.district_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>取引価格（総額）</dt><dd>{feature.properties.u_transaction_price_total_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>坪単価</dt><dd>{feature.properties.u_unit_price_per_tsubo_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>間取り</dt><dd>{feature.properties.floor_plan_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>面積</dt><dd>{feature.properties.u_area_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>建物の延床面積</dt><dd>{feature.properties.u_building_total_floor_area_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>建築年</dt><dd>{feature.properties.u_construction_year_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>建物の構造</dt><dd>{feature.properties.building_structure_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>用途地域</dt><dd>{feature.properties.land_use_name_ja}</dd></dl>)
      ret.push(<dl className='dl-list is-modal-spot'><dt>取引時点</dt><dd>{feature.properties.point_in_time_name_ja}</dd></dl>)
    }

    return ret
  }

  // 複数のfeaturesデータが同じgeojsonに含まれているので必要なデータのみ表示する。
  let isTarget = false

  // 学校データ
  if (option.fetchedServerKey === "XKT006") {
    if (feature.properties["P29_003"] == option.targetCode) {
      isTarget = true
    }
  } else if (option.fetchedServerKey === "XKT007") {

    // 幼稚園
    if (feature.properties["schoolClassCode"] == option.targetCode 
      || feature.properties["welfareFacilityMiddleClassCode"] == option.targetCode) {

      isTarget = true
    }
  } else if (option.fetchedServerKey === "XKT010") {

    // 医療機関
    if (feature.properties["P04_001"] == option.targetCode) {
      isTarget = true
    }
  } else if (option.fetchedServerKey === "XKT011") {
    // 福祉施設
    if (feature.properties["P14_005"] == option.targetCode) {
      isTarget = true
    }
  } else if (option.fetchedServerKey === "XKT017") {
    // 図書館
    isTarget = true
    
  } else if (option.fetchedServerKey === "XKT018") {

    // 役場・出張所
    if (["1", "2", "3"].includes(feature.properties["P05_002"]) && option.targetCode == "type1") {
      isTarget = true
    } else if (["4", "5"].includes(feature.properties["P05_002"]) && option.targetCode == "type2") {
      isTarget = true
    }
  } else if (option.fetchedServerKey === "XKT015") {

    // 駅
    if (["3", "4", "5"].includes(feature.properties["S12_005"]) && option.targetCode == "others") {
      isTarget = true
    } else if (feature.properties["S12_005"] == option.targetCode) {
      isTarget = true
    }
  } else if (option.fetchedServerKey === "XPT001") {
    // 不動産取引価格情報・成約価格情報
    isTarget = true
    
  }

  if(isTarget && 
    latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
        >
          <Popup
            autoPan={true}
            keepInView={true}    
            autoPanPadding={L.point(30, 70)}
            minHeight={300} 
            maxHeight={400} 
            minWidth={500} 
            closeOnClick>
            {
              createPopupContent(feature, option)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
